import assert from "@/assert";

/// Immutable promised value
export class IVar<T> extends Promise<T> {
  __resolve: ((value: T | PromiseLike<T>) => void) | null;
  __value: T | undefined;

  constructor(
    executor?: (
      resolve: (value: T | PromiseLike<T>) => void,
      reject: (reason?: unknown) => void
    ) => void
  ) {
    // Promise function such as `.then` use the same prototype as the
    // originating Promise, so we must support the same executor interface.
    if (executor !== undefined) {
      super(executor);
      this.__resolve = null;
    } else {
      let resolve = null;
      super((r) => {
        resolve = r;
      });
      this.__resolve = resolve;
      this.__value = undefined;
    }
  }

  /// Resolve the value
  fill(v: T) {
    assert(this.__resolve);
    this.__value = v;
    this.__resolve(v);
  }

  /// Return the value if filled, undefined otherwise
  peek() {
    return this.__value;
  }
}
